import { CFormLabel } from '@coreui/react-pro'
import { debounce } from 'lodash'
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import AsyncSelect from 'react-select/async'
import OrdersDataService from 'src/services/OrdersDataService'
import { selectStyles } from './select/SelectStyles'
import { SELECT_MINIMUM_LIMIT } from 'src/constants/Constants'

const OrderAsyncDropdown = forwardRef((props, ref) => {
  const { required, disabled, hasError, isClearable, handleSearchChange, handleClearOrder } = props
  const { t } = useTranslation('common')
  const [value, setValue] = useState('')
  const [error, setError] = useState(false)
  const selectRef = useRef(null)

  useImperativeHandle(ref, () => ({
    reset() {
      setValue('')
    },
  }))

  useEffect(() => {
    setValue(props.value)
  }, [props.value])
  useEffect(() => {
    if (hasError && value === '') {
      setError(true)
    }
  }, [hasError])

  const promiseOptions = debounce((query, callback) => {
    OrdersDataService.getAll({ internal_order_like: query, limit: SELECT_MINIMUM_LIMIT }).then(
      (res) => {
        let response = res.data.data.data || []
        let data = response?.map((res) => ({
          value: res.id,
          label: res.internal_order,
          for: 'order_id',
        }))
        callback(data)
      },
    )
  }, 500)

  const onChange = (event) => {
    if (!event) {
      handleClearOrder()
      setValue('')
    } else {
      setError(false)
      if (JSON.stringify(props.value) !== JSON.stringify(event)) {
        setValue(props.value)
      }
      handleSearchChange(event)
    }
  }

  return (
    <>
      <CFormLabel className={`${required ? ' required' : ''}`}>{t('order')}</CFormLabel>
      <AsyncSelect
        value={value}
        loadOptions={promiseOptions}
        defaultOptions
        isClearable={isClearable}
        onChange={onChange}
        ref={selectRef}
        styles={selectStyles(error)}
        isDisabled={disabled}
        required
      />
      {required && (
        <input
          tabIndex={-1}
          autoComplete="off"
          style={{
            opacity: 0,
            height: 0,
            position: 'absolute',
          }}
          value={value}
          onChange={() => {}}
          onFocus={() => selectRef.current.focus()}
          required={true}
        />
      )}
    </>
  )
})

export default OrderAsyncDropdown
